export default {"src":"/_next/static/media/Email_Icon.42664a0f.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};